// Generated by bin/fa-icons. Do not edit by hand.
//
// The Font Awesome icons found in server-rendered markup. Run `yarn fa:icons` after adding
// an icon, or let the pre-commit hook do it. Icons whose class name is built at runtime
// cannot be scanned and live in ./dynamic_icons.js instead.

import {
  faAppStore as brands_faAppStore,
  faCcAmex as brands_faCcAmex,
  faGoogleDrive as brands_faGoogleDrive,
  faGooglePlay as brands_faGooglePlay,
  faHubspot as brands_faHubspot,
  faLinkedin as brands_faLinkedin,
} from '@fortawesome/free-brands-svg-icons';

import {
  faAddressCard as duotone_faAddressCard,
  faArchive as duotone_faArchive,
  faArrowLeft as duotone_faArrowLeft,
  faArrowRightToBracket as duotone_faArrowRightToBracket,
  faArrowTrendDown as duotone_faArrowTrendDown,
  faArrowTrendUp as duotone_faArrowTrendUp,
  faBan as duotone_faBan,
  faBell as duotone_faBell,
  faBellConcierge as duotone_faBellConcierge,
  faBolt as duotone_faBolt,
  faBookmark as duotone_faBookmark,
  faBuilding as duotone_faBuilding,
  faBuildingCircleExclamation as duotone_faBuildingCircleExclamation,
  faBuildingColumns as duotone_faBuildingColumns,
  faCalendar as duotone_faCalendar,
  faCalendarCheck as duotone_faCalendarCheck,
  faCalendarLines as duotone_faCalendarLines,
  faCaretDown as duotone_faCaretDown,
  faCaretRight as duotone_faCaretRight,
  faCashRegister as duotone_faCashRegister,
  faChartColumn as duotone_faChartColumn,
  faChartLine as duotone_faChartLine,
  faChartUser as duotone_faChartUser,
  faCheck as duotone_faCheck,
  faCheckDouble as duotone_faCheckDouble,
  faChevronDown as duotone_faChevronDown,
  faChevronRight as duotone_faChevronRight,
  faCircleCheck as duotone_faCircleCheck,
  faCircleDivide as duotone_faCircleDivide,
  faCircleDot as duotone_faCircleDot,
  faCircleHalfStroke as duotone_faCircleHalfStroke,
  faCircleInfo as duotone_faCircleInfo,
  faCircleMinus as duotone_faCircleMinus,
  faCirclePause as duotone_faCirclePause,
  faCircleQuarter as duotone_faCircleQuarter,
  faCircleSort as duotone_faCircleSort,
  faCircleSortDown as duotone_faCircleSortDown,
  faCircleSortUp as duotone_faCircleSortUp,
  faCircleThreeQuarters as duotone_faCircleThreeQuarters,
  faCircleUser as duotone_faCircleUser,
  faClipboard as duotone_faClipboard,
  faClipboardList as duotone_faClipboardList,
  faClipboardListCheck as duotone_faClipboardListCheck,
  faClock as duotone_faClock,
  faClockRotateLeft as duotone_faClockRotateLeft,
  faCloudArrowUp as duotone_faCloudArrowUp,
  faCog as duotone_faCog,
  faCogs as duotone_faCogs,
  faComments as duotone_faComments,
  faDollarSign as duotone_faDollarSign,
  faDownload as duotone_faDownload,
  faEdit as duotone_faEdit,
  faEllipsisVertical as duotone_faEllipsisVertical,
  faEnvelope as duotone_faEnvelope,
  faEnvelopeCircleCheck as duotone_faEnvelopeCircleCheck,
  faEnvelopeDot as duotone_faEnvelopeDot,
  faEye as duotone_faEye,
  faEyeSlash as duotone_faEyeSlash,
  faFile as duotone_faFile,
  faFileArrowDown as duotone_faFileArrowDown,
  faFileChartPie as duotone_faFileChartPie,
  faFileCheck as duotone_faFileCheck,
  faFileCsv as duotone_faFileCsv,
  faFileInvoice as duotone_faFileInvoice,
  faFileInvoiceDollar as duotone_faFileInvoiceDollar,
  faFileLines as duotone_faFileLines,
  faFileSignature as duotone_faFileSignature,
  faFileText as duotone_faFileText,
  faFilter as duotone_faFilter,
  faFilterList as duotone_faFilterList,
  faFire as duotone_faFire,
  faFolder as duotone_faFolder,
  faFolderBookmark as duotone_faFolderBookmark,
  faFolderOpen as duotone_faFolderOpen,
  faFont as duotone_faFont,
  faGaugeHigh as duotone_faGaugeHigh,
  faGear as duotone_faGear,
  faGift as duotone_faGift,
  faGlobePointer as duotone_faGlobePointer,
  faGrid2Plus as duotone_faGrid2Plus,
  faHandshake as duotone_faHandshake,
  faHeadSideGear as duotone_faHeadSideGear,
  faHeartPulse as duotone_faHeartPulse,
  faHome as duotone_faHome,
  faHorizontalRule as duotone_faHorizontalRule,
  faInfinity as duotone_faInfinity,
  faInfoCircle as duotone_faInfoCircle,
  faLightbulb as duotone_faLightbulb,
  faLink as duotone_faLink,
  faListCheck as duotone_faListCheck,
  faListTimeline as duotone_faListTimeline,
  faLoader as duotone_faLoader,
  faLock as duotone_faLock,
  faMagnifyingGlass as duotone_faMagnifyingGlass,
  faMagnifyingGlassChart as duotone_faMagnifyingGlassChart,
  faMessagePlus as duotone_faMessagePlus,
  faMessageQuestion as duotone_faMessageQuestion,
  faMessageSmile as duotone_faMessageSmile,
  faMessagesQuestion as duotone_faMessagesQuestion,
  faMoneyBillTransfer as duotone_faMoneyBillTransfer,
  faMoneyBills as duotone_faMoneyBills,
  faMoneyCheckDollar as duotone_faMoneyCheckDollar,
  faMoneyCheckDollarPen as duotone_faMoneyCheckDollarPen,
  faMoon as duotone_faMoon,
  faNewspaper as duotone_faNewspaper,
  faPassport as duotone_faPassport,
  faPen as duotone_faPen,
  faPenToSquare as duotone_faPenToSquare,
  faPencil as duotone_faPencil,
  faPeopleGroup as duotone_faPeopleGroup,
  faPhoneXmark as duotone_faPhoneXmark,
  faPiggyBank as duotone_faPiggyBank,
  faPlay as duotone_faPlay,
  faPlus as duotone_faPlus,
  faRepeat as duotone_faRepeat,
  faRepeat1 as duotone_faRepeat1,
  faRightFromBracket as duotone_faRightFromBracket,
  faScaleBalanced as duotone_faScaleBalanced,
  faScrewdriverWrench as duotone_faScrewdriverWrench,
  faSearch as duotone_faSearch,
  faShieldCheck as duotone_faShieldCheck,
  faSliders as duotone_faSliders,
  faSnooze as duotone_faSnooze,
  faSparkles as duotone_faSparkles,
  faSquareCheck as duotone_faSquareCheck,
  faSquareInfo as duotone_faSquareInfo,
  faStore as duotone_faStore,
  faSync as duotone_faSync,
  faTags as duotone_faTags,
  faTasks as duotone_faTasks,
  faTrash as duotone_faTrash,
  faTriangleExclamation as duotone_faTriangleExclamation,
  faUndo as duotone_faUndo,
  faUnlink as duotone_faUnlink,
  faUpDown as duotone_faUpDown,
  faUpRightFromSquare as duotone_faUpRightFromSquare,
  faUser as duotone_faUser,
  faUserBountyHunter as duotone_faUserBountyHunter,
  faUserCircle as duotone_faUserCircle,
  faUserClock as duotone_faUserClock,
  faUserSecret as duotone_faUserSecret,
  faUserSlash as duotone_faUserSlash,
  faUsers as duotone_faUsers,
  faUsersMedical as duotone_faUsersMedical,
  faWallet as duotone_faWallet,
  faWandMagicSparkles as duotone_faWandMagicSparkles,
  faWarning as duotone_faWarning,
} from '@fortawesome/pro-duotone-svg-icons';

import {
  faAlarmClock as regular_faAlarmClock,
  faAlarmExclamation as regular_faAlarmExclamation,
  faArchive as regular_faArchive,
  faArrowDown as regular_faArrowDown,
  faArrowDownWideShort as regular_faArrowDownWideShort,
  faArrowLeft as regular_faArrowLeft,
  faArrowRight as regular_faArrowRight,
  faArrowRightLong as regular_faArrowRightLong,
  faArrowTrendUp as regular_faArrowTrendUp,
  faArrowTurnDownRight as regular_faArrowTurnDownRight,
  faArrowUp as regular_faArrowUp,
  faArrowUpArrowDown as regular_faArrowUpArrowDown,
  faArrowUpRightDots as regular_faArrowUpRightDots,
  faArrowUpRightFromSquare as regular_faArrowUpRightFromSquare,
  faArrowsRotate as regular_faArrowsRotate,
  faAt as regular_faAt,
  faBan as regular_faBan,
  faBarsFilter as regular_faBarsFilter,
  faBell as regular_faBell,
  faBellExclamation as regular_faBellExclamation,
  faBellSlash as regular_faBellSlash,
  faBook as regular_faBook,
  faBookOpenCover as regular_faBookOpenCover,
  faBriefcase as regular_faBriefcase,
  faBrowser as regular_faBrowser,
  faBug as regular_faBug,
  faBuilding as regular_faBuilding,
  faBuildingColumns as regular_faBuildingColumns,
  faBullseyeArrow as regular_faBullseyeArrow,
  faCalculator as regular_faCalculator,
  faCalendar as regular_faCalendar,
  faCalendarAlt as regular_faCalendarAlt,
  faCalendarCheck as regular_faCalendarCheck,
  faCalendarCirclePlus as regular_faCalendarCirclePlus,
  faCalendarClock as regular_faCalendarClock,
  faCalendarXmark as regular_faCalendarXmark,
  faChartColumn as regular_faChartColumn,
  faChartMixed as regular_faChartMixed,
  faCheck as regular_faCheck,
  faCheckCircle as regular_faCheckCircle,
  faChevronDown as regular_faChevronDown,
  faChevronLeft as regular_faChevronLeft,
  faChevronRight as regular_faChevronRight,
  faCircle as regular_faCircle,
  faCircleCheck as regular_faCircleCheck,
  faCircleDot as regular_faCircleDot,
  faCircleExclamation as regular_faCircleExclamation,
  faCircleHalfStroke as regular_faCircleHalfStroke,
  faCircleInfo as regular_faCircleInfo,
  faCirclePlay as regular_faCirclePlay,
  faCirclePlus as regular_faCirclePlus,
  faCircleQuestion as regular_faCircleQuestion,
  faClipboard as regular_faClipboard,
  faClipboardList as regular_faClipboardList,
  faClipboardListCheck as regular_faClipboardListCheck,
  faClock as regular_faClock,
  faClockRotateLeft as regular_faClockRotateLeft,
  faCloudArrowUp as regular_faCloudArrowUp,
  faComment as regular_faComment,
  faComments as regular_faComments,
  faCopy as regular_faCopy,
  faCreditCard as regular_faCreditCard,
  faDollar as regular_faDollar,
  faDollarSign as regular_faDollarSign,
  faDoorOpen as regular_faDoorOpen,
  faDownload as regular_faDownload,
  faEdit as regular_faEdit,
  faEllipsis as regular_faEllipsis,
  faEllipsisVertical as regular_faEllipsisVertical,
  faEnvelope as regular_faEnvelope,
  faEnvelopeOpenText as regular_faEnvelopeOpenText,
  faEraser as regular_faEraser,
  faExclamationTriangle as regular_faExclamationTriangle,
  faExpand as regular_faExpand,
  faEye as regular_faEye,
  faEyeSlash as regular_faEyeSlash,
  faFaceAngry as regular_faFaceAngry,
  faFaceFrown as regular_faFaceFrown,
  faFaceMeh as regular_faFaceMeh,
  faFaceSmileBeam as regular_faFaceSmileBeam,
  faFile as regular_faFile,
  faFileArrowDown as regular_faFileArrowDown,
  faFileCircleXmark as regular_faFileCircleXmark,
  faFileContract as regular_faFileContract,
  faFileImport as regular_faFileImport,
  faFileInvoiceDollar as regular_faFileInvoiceDollar,
  faFileLines as regular_faFileLines,
  faFilePdf as regular_faFilePdf,
  faFileSignature as regular_faFileSignature,
  faFlag as regular_faFlag,
  faFloppyDisk as regular_faFloppyDisk,
  faFolder as regular_faFolder,
  faForward as regular_faForward,
  faGear as regular_faGear,
  faGlasses as regular_faGlasses,
  faGrid2 as regular_faGrid2,
  faGripDotsVertical as regular_faGripDotsVertical,
  faGripVertical as regular_faGripVertical,
  faHand as regular_faHand,
  faHandHoldingDollar as regular_faHandHoldingDollar,
  faHandshake as regular_faHandshake,
  faHandshakeSimple as regular_faHandshakeSimple,
  faHashtag as regular_faHashtag,
  faHistory as regular_faHistory,
  faHome as regular_faHome,
  faHourglassEnd as regular_faHourglassEnd,
  faHourglassHalf as regular_faHourglassHalf,
  faHouseLock as regular_faHouseLock,
  faIdCard as regular_faIdCard,
  faInbox as regular_faInbox,
  faInfoCircle as regular_faInfoCircle,
  faKey as regular_faKey,
  faLink as regular_faLink,
  faLinkSlash as regular_faLinkSlash,
  faList as regular_faList,
  faListCheck as regular_faListCheck,
  faLock as regular_faLock,
  faMagnifyingGlass as regular_faMagnifyingGlass,
  faMessage as regular_faMessage,
  faMessageExclamation as regular_faMessageExclamation,
  faMessageLines as regular_faMessageLines,
  faMessageSmile as regular_faMessageSmile,
  faMessageSms as regular_faMessageSms,
  faMessagesQuestion as regular_faMessagesQuestion,
  faMicrochip as regular_faMicrochip,
  faMinus as regular_faMinus,
  faMobileScreenButton as regular_faMobileScreenButton,
  faMoneyBillTransfer as regular_faMoneyBillTransfer,
  faMoneyBillTrendUp as regular_faMoneyBillTrendUp,
  faMoneyCheckDollar as regular_faMoneyCheckDollar,
  faNoteSticky as regular_faNoteSticky,
  faPaperPlane as regular_faPaperPlane,
  faPaperPlaneTop as regular_faPaperPlaneTop,
  faPaperclipVertical as regular_faPaperclipVertical,
  faPen as regular_faPen,
  faPenNib as regular_faPenNib,
  faPenToSquare as regular_faPenToSquare,
  faPencil as regular_faPencil,
  faPiggyBank as regular_faPiggyBank,
  faPlus as regular_faPlus,
  faPlusCircle as regular_faPlusCircle,
  faReceipt as regular_faReceipt,
  faRefresh as regular_faRefresh,
  faReply as regular_faReply,
  faRightLeft as regular_faRightLeft,
  faRocket as regular_faRocket,
  faRotate as regular_faRotate,
  faRotateLeft as regular_faRotateLeft,
  faRotateRight as regular_faRotateRight,
  faScissors as regular_faScissors,
  faShieldCheck as regular_faShieldCheck,
  faShieldExclamation as regular_faShieldExclamation,
  faSparkles as regular_faSparkles,
  faSpellCheck as regular_faSpellCheck,
  faSpinner as regular_faSpinner,
  faSquare as regular_faSquare,
  faStar as regular_faStar,
  faTableList as regular_faTableList,
  faTasks as regular_faTasks,
  faThumbsDown as regular_faThumbsDown,
  faThumbsUp as regular_faThumbsUp,
  faThumbtack as regular_faThumbtack,
  faTicket as regular_faTicket,
  faTickets as regular_faTickets,
  faTimes as regular_faTimes,
  faTimesCircle as regular_faTimesCircle,
  faTrash as regular_faTrash,
  faTrashAlt as regular_faTrashAlt,
  faTrashCan as regular_faTrashCan,
  faTriangleExclamation as regular_faTriangleExclamation,
  faTurnUp as regular_faTurnUp,
  faUndo as regular_faUndo,
  faUpload as regular_faUpload,
  faUser as regular_faUser,
  faUserClock as regular_faUserClock,
  faUserPen as regular_faUserPen,
  faUserPlus as regular_faUserPlus,
  faUserTag as regular_faUserTag,
  faUserTie as regular_faUserTie,
  faUserXmark as regular_faUserXmark,
  faUsers as regular_faUsers,
  faWallet as regular_faWallet,
  faWandMagicSparkles as regular_faWandMagicSparkles,
  faWarning as regular_faWarning,
  faWavePulse as regular_faWavePulse,
  faWindowRestore as regular_faWindowRestore,
  faXmark as regular_faXmark,
} from '@fortawesome/pro-regular-svg-icons';

import {
  faAddressBook as solid_faAddressBook,
  faAddressCard as solid_faAddressCard,
  faAlarmClock as solid_faAlarmClock,
  faAlignLeft as solid_faAlignLeft,
  faArchive as solid_faArchive,
  faArrowDown as solid_faArrowDown,
  faArrowDownLeft as solid_faArrowDownLeft,
  faArrowLeft as solid_faArrowLeft,
  faArrowRight as solid_faArrowRight,
  faArrowRightLong as solid_faArrowRightLong,
  faArrowTrendDown as solid_faArrowTrendDown,
  faArrowTrendUp as solid_faArrowTrendUp,
  faArrowUp as solid_faArrowUp,
  faArrowUpArrowDown as solid_faArrowUpArrowDown,
  faArrowUpRight as solid_faArrowUpRight,
  faArrowUpRightFromSquare as solid_faArrowUpRightFromSquare,
  faArrowsRotate as solid_faArrowsRotate,
  faBabyCarriage as solid_faBabyCarriage,
  faBadgeCheck as solid_faBadgeCheck,
  faBan as solid_faBan,
  faBars as solid_faBars,
  faBarsFilter as solid_faBarsFilter,
  faBell as solid_faBell,
  faBellOn as solid_faBellOn,
  faBellSlash as solid_faBellSlash,
  faBirthdayCake as solid_faBirthdayCake,
  faBolt as solid_faBolt,
  faBoxesStacked as solid_faBoxesStacked,
  faBriefcase as solid_faBriefcase,
  faBuilding as solid_faBuilding,
  faBuildingColumns as solid_faBuildingColumns,
  faBullseye as solid_faBullseye,
  faCalculator as solid_faCalculator,
  faCalendar as solid_faCalendar,
  faCalendarAlt as solid_faCalendarAlt,
  faCalendarCheck as solid_faCalendarCheck,
  faCalendarCirclePlus as solid_faCalendarCirclePlus,
  faCalendarDay as solid_faCalendarDay,
  faCalendarPlus as solid_faCalendarPlus,
  faCalendarWeek as solid_faCalendarWeek,
  faCalendarXmark as solid_faCalendarXmark,
  faCamera as solid_faCamera,
  faCaretDown as solid_faCaretDown,
  faCaretRight as solid_faCaretRight,
  faCaretUp as solid_faCaretUp,
  faChartBar as solid_faChartBar,
  faChartLine as solid_faChartLine,
  faChartPie as solid_faChartPie,
  faCheck as solid_faCheck,
  faCheckCircle as solid_faCheckCircle,
  faCheckDouble as solid_faCheckDouble,
  faChevronDown as solid_faChevronDown,
  faChevronLeft as solid_faChevronLeft,
  faChevronRight as solid_faChevronRight,
  faChevronUp as solid_faChevronUp,
  faChild as solid_faChild,
  faCircle as solid_faCircle,
  faCircleCheck as solid_faCircleCheck,
  faCircleDot as solid_faCircleDot,
  faCircleExclamation as solid_faCircleExclamation,
  faCircleHalfStroke as solid_faCircleHalfStroke,
  faCircleInfo as solid_faCircleInfo,
  faCircleNotch as solid_faCircleNotch,
  faCirclePlay as solid_faCirclePlay,
  faCircleQuarterStroke as solid_faCircleQuarterStroke,
  faCircleQuestion as solid_faCircleQuestion,
  faCircleSmall as solid_faCircleSmall,
  faCircleStop as solid_faCircleStop,
  faCircleThreeQuartersStroke as solid_faCircleThreeQuartersStroke,
  faCircleXmark as solid_faCircleXmark,
  faCity as solid_faCity,
  faClipboardList as solid_faClipboardList,
  faClock as solid_faClock,
  faClockRotateLeft as solid_faClockRotateLeft,
  faCloudUploadAlt as solid_faCloudUploadAlt,
  faCode as solid_faCode,
  faCog as solid_faCog,
  faCoins as solid_faCoins,
  faColumns as solid_faColumns,
  faComment as solid_faComment,
  faCommentDots as solid_faCommentDots,
  faCommentPlus as solid_faCommentPlus,
  faCommentSms as solid_faCommentSms,
  faComments as solid_faComments,
  faCompress as solid_faCompress,
  faCopy as solid_faCopy,
  faCreditCard as solid_faCreditCard,
  faCrystalBall as solid_faCrystalBall,
  faDatabase as solid_faDatabase,
  faDesktop as solid_faDesktop,
  faDiagramSubtask as solid_faDiagramSubtask,
  faDollarSign as solid_faDollarSign,
  faDoorOpen as solid_faDoorOpen,
  faDownLeftAndUpRightToCenter as solid_faDownLeftAndUpRightToCenter,
  faDownload as solid_faDownload,
  faEdit as solid_faEdit,
  faEllipsis as solid_faEllipsis,
  faEllipsisH as solid_faEllipsisH,
  faEllipsisVertical as solid_faEllipsisVertical,
  faEnvelope as solid_faEnvelope,
  faEnvelopeOpen as solid_faEnvelopeOpen,
  faEnvelopeOpenText as solid_faEnvelopeOpenText,
  faExchangeAlt as solid_faExchangeAlt,
  faExclamationCircle as solid_faExclamationCircle,
  faExclamationTriangle as solid_faExclamationTriangle,
  faExpand as solid_faExpand,
  faExternalLink as solid_faExternalLink,
  faExternalLinkAlt as solid_faExternalLinkAlt,
  faEye as solid_faEye,
  faEyeSlash as solid_faEyeSlash,
  faFaceFrown as solid_faFaceFrown,
  faFaceMeh as solid_faFaceMeh,
  faFaceSmileBeam as solid_faFaceSmileBeam,
  faFile as solid_faFile,
  faFileAlt as solid_faFileAlt,
  faFileArrowDown as solid_faFileArrowDown,
  faFileCsv as solid_faFileCsv,
  faFileExcel as solid_faFileExcel,
  faFileExport as solid_faFileExport,
  faFileImage as solid_faFileImage,
  faFileInvoice as solid_faFileInvoice,
  faFileInvoiceDollar as solid_faFileInvoiceDollar,
  faFileJpg as solid_faFileJpg,
  faFileLines as solid_faFileLines,
  faFilePdf as solid_faFilePdf,
  faFilePng as solid_faFilePng,
  faFileSignature as solid_faFileSignature,
  faFileText as solid_faFileText,
  faFileUpload as solid_faFileUpload,
  faFileWord as solid_faFileWord,
  faFileZipper as solid_faFileZipper,
  faFilter as solid_faFilter,
  faFlag as solid_faFlag,
  faFlagCheckered as solid_faFlagCheckered,
  faFloppyDisk as solid_faFloppyDisk,
  faFolder as solid_faFolder,
  faFolderOpen as solid_faFolderOpen,
  faGear as solid_faGear,
  faGlobeAmericas as solid_faGlobeAmericas,
  faGripVertical as solid_faGripVertical,
  faHandHoldingDollar as solid_faHandHoldingDollar,
  faHeadset as solid_faHeadset,
  faHistory as solid_faHistory,
  faHome as solid_faHome,
  faHourglass as solid_faHourglass,
  faHourglassClock as solid_faHourglassClock,
  faHourglassHalf as solid_faHourglassHalf,
  faHourglassStart as solid_faHourglassStart,
  faIcons as solid_faIcons,
  faIdCard as solid_faIdCard,
  faImage as solid_faImage,
  faInbox as solid_faInbox,
  faIndustry as solid_faIndustry,
  faInfo as solid_faInfo,
  faInfoCircle as solid_faInfoCircle,
  faKey as solid_faKey,
  faLandmark as solid_faLandmark,
  faLayerGroup as solid_faLayerGroup,
  faLightbulb as solid_faLightbulb,
  faLink as solid_faLink,
  faList as solid_faList,
  faListCheck as solid_faListCheck,
  faListTree as solid_faListTree,
  faListUl as solid_faListUl,
  faLoader as solid_faLoader,
  faLocationDot as solid_faLocationDot,
  faLock as solid_faLock,
  faLockOpen as solid_faLockOpen,
  faMagic as solid_faMagic,
  faMagnifyingGlass as solid_faMagnifyingGlass,
  faMailBulk as solid_faMailBulk,
  faMapMarker as solid_faMapMarker,
  faMapMarkerAlt as solid_faMapMarkerAlt,
  faMessage as solid_faMessage,
  faMessageExclamation as solid_faMessageExclamation,
  faMinus as solid_faMinus,
  faMinusCircle as solid_faMinusCircle,
  faMobileAlt as solid_faMobileAlt,
  faMobileScreen as solid_faMobileScreen,
  faMobileScreenButton as solid_faMobileScreenButton,
  faMoneyBillTransfer as solid_faMoneyBillTransfer,
  faMoneyCheck as solid_faMoneyCheck,
  faMoneyCheckDollar as solid_faMoneyCheckDollar,
  faMoon as solid_faMoon,
  faMugHot as solid_faMugHot,
  faPaperPlane as solid_faPaperPlane,
  faPaperclip as solid_faPaperclip,
  faPen as solid_faPen,
  faPenFancy as solid_faPenFancy,
  faPencil as solid_faPencil,
  faPencilAlt as solid_faPencilAlt,
  faPeopleGroup as solid_faPeopleGroup,
  faPerson as solid_faPerson,
  faPhone as solid_faPhone,
  faPiggyBank as solid_faPiggyBank,
  faPlay as solid_faPlay,
  faPlayCircle as solid_faPlayCircle,
  faPlug as solid_faPlug,
  faPlus as solid_faPlus,
  faPlusLarge as solid_faPlusLarge,
  faPowerOff as solid_faPowerOff,
  faQuestion as solid_faQuestion,
  faQuestionCircle as solid_faQuestionCircle,
  faReceipt as solid_faReceipt,
  faRedo as solid_faRedo,
  faRepeat as solid_faRepeat,
  faReply as solid_faReply,
  faReplyAll as solid_faReplyAll,
  faReplyClock as solid_faReplyClock,
  faRoad as solid_faRoad,
  faRobot as solid_faRobot,
  faRotate as solid_faRotate,
  faRotateLeft as solid_faRotateLeft,
  faRotateRight as solid_faRotateRight,
  faRoute as solid_faRoute,
  faSave as solid_faSave,
  faSealExclamation as solid_faSealExclamation,
  faSearch as solid_faSearch,
  faShare as solid_faShare,
  faShareAlt as solid_faShareAlt,
  faShieldCheck as solid_faShieldCheck,
  faSignature as solid_faSignature,
  faSitemap as solid_faSitemap,
  faSlidersH as solid_faSlidersH,
  faSortDown as solid_faSortDown,
  faSortUp as solid_faSortUp,
  faSpinner as solid_faSpinner,
  faSquare as solid_faSquare,
  faSquareCheck as solid_faSquareCheck,
  faSquareMinus as solid_faSquareMinus,
  faSquarePlus as solid_faSquarePlus,
  faStar as solid_faStar,
  faStarHalfStroke as solid_faStarHalfStroke,
  faStickyNote as solid_faStickyNote,
  faSun as solid_faSun,
  faTableColumns as solid_faTableColumns,
  faTag as solid_faTag,
  faTags as solid_faTags,
  faTasks as solid_faTasks,
  faThumbsDown as solid_faThumbsDown,
  faThumbtack as solid_faThumbtack,
  faTicket as solid_faTicket,
  faTimelineArrow as solid_faTimelineArrow,
  faTimes as solid_faTimes,
  faTimesCircle as solid_faTimesCircle,
  faToggleOff as solid_faToggleOff,
  faToggleOn as solid_faToggleOn,
  faTools as solid_faTools,
  faTrash as solid_faTrash,
  faTrashAlt as solid_faTrashAlt,
  faTrashArrowUp as solid_faTrashArrowUp,
  faTrashCan as solid_faTrashCan,
  faTriangleExclamation as solid_faTriangleExclamation,
  faUndo as solid_faUndo,
  faUniversalAccess as solid_faUniversalAccess,
  faUniversity as solid_faUniversity,
  faUnlock as solid_faUnlock,
  faUpDown as solid_faUpDown,
  faUpRightAndDownLeftFromCenter as solid_faUpRightAndDownLeftFromCenter,
  faUpRightFromSquare as solid_faUpRightFromSquare,
  faUpload as solid_faUpload,
  faUser as solid_faUser,
  faUserCheck as solid_faUserCheck,
  faUserEdit as solid_faUserEdit,
  faUserFriends as solid_faUserFriends,
  faUserGear as solid_faUserGear,
  faUserLock as solid_faUserLock,
  faUserPlus as solid_faUserPlus,
  faUserShield as solid_faUserShield,
  faUserTie as solid_faUserTie,
  faUserTimes as solid_faUserTimes,
  faUsers as solid_faUsers,
  faVault as solid_faVault,
  faVideo as solid_faVideo,
  faWallet as solid_faWallet,
  faWandMagicSparkles as solid_faWandMagicSparkles,
  faWarehouse as solid_faWarehouse,
  faWarning as solid_faWarning,
  faWavePulse as solid_faWavePulse,
  faWrench as solid_faWrench,
  faXmark as solid_faXmark,
} from '@fortawesome/pro-solid-svg-icons';

export const generatedIcons = [
  brands_faAppStore,
  brands_faCcAmex,
  brands_faGoogleDrive,
  brands_faGooglePlay,
  brands_faHubspot,
  brands_faLinkedin,
  duotone_faAddressCard,
  duotone_faArchive,
  duotone_faArrowLeft,
  duotone_faArrowRightToBracket,
  duotone_faArrowTrendDown,
  duotone_faArrowTrendUp,
  duotone_faBan,
  duotone_faBell,
  duotone_faBellConcierge,
  duotone_faBolt,
  duotone_faBookmark,
  duotone_faBuilding,
  duotone_faBuildingCircleExclamation,
  duotone_faBuildingColumns,
  duotone_faCalendar,
  duotone_faCalendarCheck,
  duotone_faCalendarLines,
  duotone_faCaretDown,
  duotone_faCaretRight,
  duotone_faCashRegister,
  duotone_faChartColumn,
  duotone_faChartLine,
  duotone_faChartUser,
  duotone_faCheck,
  duotone_faCheckDouble,
  duotone_faChevronDown,
  duotone_faChevronRight,
  duotone_faCircleCheck,
  duotone_faCircleDivide,
  duotone_faCircleDot,
  duotone_faCircleHalfStroke,
  duotone_faCircleInfo,
  duotone_faCircleMinus,
  duotone_faCirclePause,
  duotone_faCircleQuarter,
  duotone_faCircleSort,
  duotone_faCircleSortDown,
  duotone_faCircleSortUp,
  duotone_faCircleThreeQuarters,
  duotone_faCircleUser,
  duotone_faClipboard,
  duotone_faClipboardList,
  duotone_faClipboardListCheck,
  duotone_faClock,
  duotone_faClockRotateLeft,
  duotone_faCloudArrowUp,
  duotone_faCog,
  duotone_faCogs,
  duotone_faComments,
  duotone_faDollarSign,
  duotone_faDownload,
  duotone_faEdit,
  duotone_faEllipsisVertical,
  duotone_faEnvelope,
  duotone_faEnvelopeCircleCheck,
  duotone_faEnvelopeDot,
  duotone_faEye,
  duotone_faEyeSlash,
  duotone_faFile,
  duotone_faFileArrowDown,
  duotone_faFileChartPie,
  duotone_faFileCheck,
  duotone_faFileCsv,
  duotone_faFileInvoice,
  duotone_faFileInvoiceDollar,
  duotone_faFileLines,
  duotone_faFileSignature,
  duotone_faFileText,
  duotone_faFilter,
  duotone_faFilterList,
  duotone_faFire,
  duotone_faFolder,
  duotone_faFolderBookmark,
  duotone_faFolderOpen,
  duotone_faFont,
  duotone_faGaugeHigh,
  duotone_faGear,
  duotone_faGift,
  duotone_faGlobePointer,
  duotone_faGrid2Plus,
  duotone_faHandshake,
  duotone_faHeadSideGear,
  duotone_faHeartPulse,
  duotone_faHome,
  duotone_faHorizontalRule,
  duotone_faInfinity,
  duotone_faInfoCircle,
  duotone_faLightbulb,
  duotone_faLink,
  duotone_faListCheck,
  duotone_faListTimeline,
  duotone_faLoader,
  duotone_faLock,
  duotone_faMagnifyingGlass,
  duotone_faMagnifyingGlassChart,
  duotone_faMessagePlus,
  duotone_faMessageQuestion,
  duotone_faMessageSmile,
  duotone_faMessagesQuestion,
  duotone_faMoneyBillTransfer,
  duotone_faMoneyBills,
  duotone_faMoneyCheckDollar,
  duotone_faMoneyCheckDollarPen,
  duotone_faMoon,
  duotone_faNewspaper,
  duotone_faPassport,
  duotone_faPen,
  duotone_faPenToSquare,
  duotone_faPencil,
  duotone_faPeopleGroup,
  duotone_faPhoneXmark,
  duotone_faPiggyBank,
  duotone_faPlay,
  duotone_faPlus,
  duotone_faRepeat,
  duotone_faRepeat1,
  duotone_faRightFromBracket,
  duotone_faScaleBalanced,
  duotone_faScrewdriverWrench,
  duotone_faSearch,
  duotone_faShieldCheck,
  duotone_faSliders,
  duotone_faSnooze,
  duotone_faSparkles,
  duotone_faSquareCheck,
  duotone_faSquareInfo,
  duotone_faStore,
  duotone_faSync,
  duotone_faTags,
  duotone_faTasks,
  duotone_faTrash,
  duotone_faTriangleExclamation,
  duotone_faUndo,
  duotone_faUnlink,
  duotone_faUpDown,
  duotone_faUpRightFromSquare,
  duotone_faUser,
  duotone_faUserBountyHunter,
  duotone_faUserCircle,
  duotone_faUserClock,
  duotone_faUserSecret,
  duotone_faUserSlash,
  duotone_faUsers,
  duotone_faUsersMedical,
  duotone_faWallet,
  duotone_faWandMagicSparkles,
  duotone_faWarning,
  regular_faAlarmClock,
  regular_faAlarmExclamation,
  regular_faArchive,
  regular_faArrowDown,
  regular_faArrowDownWideShort,
  regular_faArrowLeft,
  regular_faArrowRight,
  regular_faArrowRightLong,
  regular_faArrowTrendUp,
  regular_faArrowTurnDownRight,
  regular_faArrowUp,
  regular_faArrowUpArrowDown,
  regular_faArrowUpRightDots,
  regular_faArrowUpRightFromSquare,
  regular_faArrowsRotate,
  regular_faAt,
  regular_faBan,
  regular_faBarsFilter,
  regular_faBell,
  regular_faBellExclamation,
  regular_faBellSlash,
  regular_faBook,
  regular_faBookOpenCover,
  regular_faBriefcase,
  regular_faBrowser,
  regular_faBug,
  regular_faBuilding,
  regular_faBuildingColumns,
  regular_faBullseyeArrow,
  regular_faCalculator,
  regular_faCalendar,
  regular_faCalendarAlt,
  regular_faCalendarCheck,
  regular_faCalendarCirclePlus,
  regular_faCalendarClock,
  regular_faCalendarXmark,
  regular_faChartColumn,
  regular_faChartMixed,
  regular_faCheck,
  regular_faCheckCircle,
  regular_faChevronDown,
  regular_faChevronLeft,
  regular_faChevronRight,
  regular_faCircle,
  regular_faCircleCheck,
  regular_faCircleDot,
  regular_faCircleExclamation,
  regular_faCircleHalfStroke,
  regular_faCircleInfo,
  regular_faCirclePlay,
  regular_faCirclePlus,
  regular_faCircleQuestion,
  regular_faClipboard,
  regular_faClipboardList,
  regular_faClipboardListCheck,
  regular_faClock,
  regular_faClockRotateLeft,
  regular_faCloudArrowUp,
  regular_faComment,
  regular_faComments,
  regular_faCopy,
  regular_faCreditCard,
  regular_faDollar,
  regular_faDollarSign,
  regular_faDoorOpen,
  regular_faDownload,
  regular_faEdit,
  regular_faEllipsis,
  regular_faEllipsisVertical,
  regular_faEnvelope,
  regular_faEnvelopeOpenText,
  regular_faEraser,
  regular_faExclamationTriangle,
  regular_faExpand,
  regular_faEye,
  regular_faEyeSlash,
  regular_faFaceAngry,
  regular_faFaceFrown,
  regular_faFaceMeh,
  regular_faFaceSmileBeam,
  regular_faFile,
  regular_faFileArrowDown,
  regular_faFileCircleXmark,
  regular_faFileContract,
  regular_faFileImport,
  regular_faFileInvoiceDollar,
  regular_faFileLines,
  regular_faFilePdf,
  regular_faFileSignature,
  regular_faFlag,
  regular_faFloppyDisk,
  regular_faFolder,
  regular_faForward,
  regular_faGear,
  regular_faGlasses,
  regular_faGrid2,
  regular_faGripDotsVertical,
  regular_faGripVertical,
  regular_faHand,
  regular_faHandHoldingDollar,
  regular_faHandshake,
  regular_faHandshakeSimple,
  regular_faHashtag,
  regular_faHistory,
  regular_faHome,
  regular_faHourglassEnd,
  regular_faHourglassHalf,
  regular_faHouseLock,
  regular_faIdCard,
  regular_faInbox,
  regular_faInfoCircle,
  regular_faKey,
  regular_faLink,
  regular_faLinkSlash,
  regular_faList,
  regular_faListCheck,
  regular_faLock,
  regular_faMagnifyingGlass,
  regular_faMessage,
  regular_faMessageExclamation,
  regular_faMessageLines,
  regular_faMessageSmile,
  regular_faMessageSms,
  regular_faMessagesQuestion,
  regular_faMicrochip,
  regular_faMinus,
  regular_faMobileScreenButton,
  regular_faMoneyBillTransfer,
  regular_faMoneyBillTrendUp,
  regular_faMoneyCheckDollar,
  regular_faNoteSticky,
  regular_faPaperPlane,
  regular_faPaperPlaneTop,
  regular_faPaperclipVertical,
  regular_faPen,
  regular_faPenNib,
  regular_faPenToSquare,
  regular_faPencil,
  regular_faPiggyBank,
  regular_faPlus,
  regular_faPlusCircle,
  regular_faReceipt,
  regular_faRefresh,
  regular_faReply,
  regular_faRightLeft,
  regular_faRocket,
  regular_faRotate,
  regular_faRotateLeft,
  regular_faRotateRight,
  regular_faScissors,
  regular_faShieldCheck,
  regular_faShieldExclamation,
  regular_faSparkles,
  regular_faSpellCheck,
  regular_faSpinner,
  regular_faSquare,
  regular_faStar,
  regular_faTableList,
  regular_faTasks,
  regular_faThumbsDown,
  regular_faThumbsUp,
  regular_faThumbtack,
  regular_faTicket,
  regular_faTickets,
  regular_faTimes,
  regular_faTimesCircle,
  regular_faTrash,
  regular_faTrashAlt,
  regular_faTrashCan,
  regular_faTriangleExclamation,
  regular_faTurnUp,
  regular_faUndo,
  regular_faUpload,
  regular_faUser,
  regular_faUserClock,
  regular_faUserPen,
  regular_faUserPlus,
  regular_faUserTag,
  regular_faUserTie,
  regular_faUserXmark,
  regular_faUsers,
  regular_faWallet,
  regular_faWandMagicSparkles,
  regular_faWarning,
  regular_faWavePulse,
  regular_faWindowRestore,
  regular_faXmark,
  solid_faAddressBook,
  solid_faAddressCard,
  solid_faAlarmClock,
  solid_faAlignLeft,
  solid_faArchive,
  solid_faArrowDown,
  solid_faArrowDownLeft,
  solid_faArrowLeft,
  solid_faArrowRight,
  solid_faArrowRightLong,
  solid_faArrowTrendDown,
  solid_faArrowTrendUp,
  solid_faArrowUp,
  solid_faArrowUpArrowDown,
  solid_faArrowUpRight,
  solid_faArrowUpRightFromSquare,
  solid_faArrowsRotate,
  solid_faBabyCarriage,
  solid_faBadgeCheck,
  solid_faBan,
  solid_faBars,
  solid_faBarsFilter,
  solid_faBell,
  solid_faBellOn,
  solid_faBellSlash,
  solid_faBirthdayCake,
  solid_faBolt,
  solid_faBoxesStacked,
  solid_faBriefcase,
  solid_faBuilding,
  solid_faBuildingColumns,
  solid_faBullseye,
  solid_faCalculator,
  solid_faCalendar,
  solid_faCalendarAlt,
  solid_faCalendarCheck,
  solid_faCalendarCirclePlus,
  solid_faCalendarDay,
  solid_faCalendarPlus,
  solid_faCalendarWeek,
  solid_faCalendarXmark,
  solid_faCamera,
  solid_faCaretDown,
  solid_faCaretRight,
  solid_faCaretUp,
  solid_faChartBar,
  solid_faChartLine,
  solid_faChartPie,
  solid_faCheck,
  solid_faCheckCircle,
  solid_faCheckDouble,
  solid_faChevronDown,
  solid_faChevronLeft,
  solid_faChevronRight,
  solid_faChevronUp,
  solid_faChild,
  solid_faCircle,
  solid_faCircleCheck,
  solid_faCircleDot,
  solid_faCircleExclamation,
  solid_faCircleHalfStroke,
  solid_faCircleInfo,
  solid_faCircleNotch,
  solid_faCirclePlay,
  solid_faCircleQuarterStroke,
  solid_faCircleQuestion,
  solid_faCircleSmall,
  solid_faCircleStop,
  solid_faCircleThreeQuartersStroke,
  solid_faCircleXmark,
  solid_faCity,
  solid_faClipboardList,
  solid_faClock,
  solid_faClockRotateLeft,
  solid_faCloudUploadAlt,
  solid_faCode,
  solid_faCog,
  solid_faCoins,
  solid_faColumns,
  solid_faComment,
  solid_faCommentDots,
  solid_faCommentPlus,
  solid_faCommentSms,
  solid_faComments,
  solid_faCompress,
  solid_faCopy,
  solid_faCreditCard,
  solid_faCrystalBall,
  solid_faDatabase,
  solid_faDesktop,
  solid_faDiagramSubtask,
  solid_faDollarSign,
  solid_faDoorOpen,
  solid_faDownLeftAndUpRightToCenter,
  solid_faDownload,
  solid_faEdit,
  solid_faEllipsis,
  solid_faEllipsisH,
  solid_faEllipsisVertical,
  solid_faEnvelope,
  solid_faEnvelopeOpen,
  solid_faEnvelopeOpenText,
  solid_faExchangeAlt,
  solid_faExclamationCircle,
  solid_faExclamationTriangle,
  solid_faExpand,
  solid_faExternalLink,
  solid_faExternalLinkAlt,
  solid_faEye,
  solid_faEyeSlash,
  solid_faFaceFrown,
  solid_faFaceMeh,
  solid_faFaceSmileBeam,
  solid_faFile,
  solid_faFileAlt,
  solid_faFileArrowDown,
  solid_faFileCsv,
  solid_faFileExcel,
  solid_faFileExport,
  solid_faFileImage,
  solid_faFileInvoice,
  solid_faFileInvoiceDollar,
  solid_faFileJpg,
  solid_faFileLines,
  solid_faFilePdf,
  solid_faFilePng,
  solid_faFileSignature,
  solid_faFileText,
  solid_faFileUpload,
  solid_faFileWord,
  solid_faFileZipper,
  solid_faFilter,
  solid_faFlag,
  solid_faFlagCheckered,
  solid_faFloppyDisk,
  solid_faFolder,
  solid_faFolderOpen,
  solid_faGear,
  solid_faGlobeAmericas,
  solid_faGripVertical,
  solid_faHandHoldingDollar,
  solid_faHeadset,
  solid_faHistory,
  solid_faHome,
  solid_faHourglass,
  solid_faHourglassClock,
  solid_faHourglassHalf,
  solid_faHourglassStart,
  solid_faIcons,
  solid_faIdCard,
  solid_faImage,
  solid_faInbox,
  solid_faIndustry,
  solid_faInfo,
  solid_faInfoCircle,
  solid_faKey,
  solid_faLandmark,
  solid_faLayerGroup,
  solid_faLightbulb,
  solid_faLink,
  solid_faList,
  solid_faListCheck,
  solid_faListTree,
  solid_faListUl,
  solid_faLoader,
  solid_faLocationDot,
  solid_faLock,
  solid_faLockOpen,
  solid_faMagic,
  solid_faMagnifyingGlass,
  solid_faMailBulk,
  solid_faMapMarker,
  solid_faMapMarkerAlt,
  solid_faMessage,
  solid_faMessageExclamation,
  solid_faMinus,
  solid_faMinusCircle,
  solid_faMobileAlt,
  solid_faMobileScreen,
  solid_faMobileScreenButton,
  solid_faMoneyBillTransfer,
  solid_faMoneyCheck,
  solid_faMoneyCheckDollar,
  solid_faMoon,
  solid_faMugHot,
  solid_faPaperPlane,
  solid_faPaperclip,
  solid_faPen,
  solid_faPenFancy,
  solid_faPencil,
  solid_faPencilAlt,
  solid_faPeopleGroup,
  solid_faPerson,
  solid_faPhone,
  solid_faPiggyBank,
  solid_faPlay,
  solid_faPlayCircle,
  solid_faPlug,
  solid_faPlus,
  solid_faPlusLarge,
  solid_faPowerOff,
  solid_faQuestion,
  solid_faQuestionCircle,
  solid_faReceipt,
  solid_faRedo,
  solid_faRepeat,
  solid_faReply,
  solid_faReplyAll,
  solid_faReplyClock,
  solid_faRoad,
  solid_faRobot,
  solid_faRotate,
  solid_faRotateLeft,
  solid_faRotateRight,
  solid_faRoute,
  solid_faSave,
  solid_faSealExclamation,
  solid_faSearch,
  solid_faShare,
  solid_faShareAlt,
  solid_faShieldCheck,
  solid_faSignature,
  solid_faSitemap,
  solid_faSlidersH,
  solid_faSortDown,
  solid_faSortUp,
  solid_faSpinner,
  solid_faSquare,
  solid_faSquareCheck,
  solid_faSquareMinus,
  solid_faSquarePlus,
  solid_faStar,
  solid_faStarHalfStroke,
  solid_faStickyNote,
  solid_faSun,
  solid_faTableColumns,
  solid_faTag,
  solid_faTags,
  solid_faTasks,
  solid_faThumbsDown,
  solid_faThumbtack,
  solid_faTicket,
  solid_faTimelineArrow,
  solid_faTimes,
  solid_faTimesCircle,
  solid_faToggleOff,
  solid_faToggleOn,
  solid_faTools,
  solid_faTrash,
  solid_faTrashAlt,
  solid_faTrashArrowUp,
  solid_faTrashCan,
  solid_faTriangleExclamation,
  solid_faUndo,
  solid_faUniversalAccess,
  solid_faUniversity,
  solid_faUnlock,
  solid_faUpDown,
  solid_faUpRightAndDownLeftFromCenter,
  solid_faUpRightFromSquare,
  solid_faUpload,
  solid_faUser,
  solid_faUserCheck,
  solid_faUserEdit,
  solid_faUserFriends,
  solid_faUserGear,
  solid_faUserLock,
  solid_faUserPlus,
  solid_faUserShield,
  solid_faUserTie,
  solid_faUserTimes,
  solid_faUsers,
  solid_faVault,
  solid_faVideo,
  solid_faWallet,
  solid_faWandMagicSparkles,
  solid_faWarehouse,
  solid_faWarning,
  solid_faWavePulse,
  solid_faWrench,
  solid_faXmark,
];
